import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useState } from 'react';
import get_1 from '../../node_modules/lodash/get.js';
import styled from 'styled-components';
import PropTypes from '../../node_modules/prop-types/index.js';
import { Field } from 'formik';
import Text from '../text/text.component.js';
import '../../App.css.js';
import { backgroundColor, placeholderColor, errorStyleFocus, errorStyle, color, addonStartStyle, addonEndStyle } from '../../theme/textfield-theme.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/*
  const PlaceHolder = styled(Box)`
    ${props =>
      props.hasFocus &&
      css`
        transform: scale(0.75) translateY(-90%);
        transform-origin: left;
      `} transition: tranhsform 150ms cubic-bezier(0.4, 0, 0.2, 1);
  `;
  */

var Container = styled.div.withConfig({
  displayName: "textfield-otpcomponent__Container",
  componentId: "sc-1ys6qwa-0"
})(["min-width:0px;min-height:0px;width:100%;"]);
var TextfieldForm = styled.div.withConfig({
  displayName: "textfield-otpcomponent__TextfieldForm",
  componentId: "sc-1ys6qwa-1"
})(["", " padding-left:16px;padding-right:16px;border-radius:16px;position:relative;width:100%;height:56px;& > .textfield-label{display:block;position:absolute;transition:all 0.3s;left:16px;top:calc(50% - 11px);user-select:none;transform-origin:left top;}& > .textfield-input{box-shadow:none;border-style:none;transition:all 0.3s;}.textfield-input::placeholder{color:transparent !important;user-select:none;}& .textfield-input:focus,& .textfield-input:not(:placeholder-shown){&::placeholder{", "}}& .textfield-input:focus + .textfield-label,& .textfield-input:not(:placeholder-shown) + .textfield-label{top:8px;transform:scale(0.75);}"], backgroundColor, function (props) {
  return props.hasPlaceholder ? placeholderColor : "";
});
var Line = styled.div.withConfig({
  displayName: "textfield-otpcomponent__Line",
  componentId: "sc-1ys6qwa-2"
})(["display:-webkit-inline-box;"]);
var LineInputBorder = styled.div.withConfig({
  displayName: "textfield-otpcomponent__LineInputBorder",
  componentId: "sc-1ys6qwa-3"
})(["width:100%;height:1px;background-color:transparent;& div{width:", ";opacity:", ";height:1px;transition:all 0.2s cubic-bezier(0.4,0,0.2,1);", "}"], function (props) {
  return props.hasFocus || props.hasErrors == "true" ? "100%" : "0px";
}, function (props) {
  return props.hasFocus || props.hasErrors == "true" ? "1" : "0";
}, function (props) {
  return props.hasFocus || props.hasErrors == "true" ? errorStyleFocus : errorStyle;
});
var TextField = styled.input.withConfig({
  displayName: "textfield-otpcomponent__TextField",
  componentId: "sc-1ys6qwa-4"
})(["outline:none !important;", " ", " height:32px;width:100%;-webkit-appearance:none;font-size:14px !important;font-family:Graphik-Regular,Arial !important;font-weight:400;transition:letter-spacing 0s;letter-spacing:none;padding:23px 0px 0px 0px;&:not(:placeholder-shown){transition:letter-spacing 0s;letter-spacing:8px;}", " ", ""], color, backgroundColor, addonStartStyle, addonEndStyle);
/**
 * @deprecated
 */

var WrappedTextInput = function WrappedTextInput(_ref) {
  var _ref2;
  var fontFamily = _ref.fontFamily,
    fontSize = _ref.fontSize,
    baseColor = _ref.baseColor,
    height = _ref.height,
    color = _ref.color,
    border = _ref.border,
    name = _ref.name,
    id = _ref.id,
    label = _ref.label,
    placeholder = _ref.placeholder,
    noMargin = _ref.noMargin,
    autoFocus = _ref.autoFocus,
    autoComplete = _ref.autoComplete,
    textName = _ref.textName,
    extraField = _ref.extraField,
    tabIndex = _ref.tabIndex,
    allowSpace = _ref.allowSpace,
    style = _ref.style,
    wrapperStyle = _ref.wrapperStyle;
  _ref.lng;
  var length = _ref.length;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var textInput = /*#__PURE__*/React__default.createRef();
  return /*#__PURE__*/React__default.createElement(Container, {
    baseColor: baseColor,
    style: _objectSpread({
      marginBottom: noMargin ? "0px" : "4px",
      width: "100%"
    }, wrapperStyle)
  }, textName ? /*#__PURE__*/React__default.createElement("div", {
    style: (_ref2 = {
      paddingBottom: "10px",
      display: "flex",
      height: "12px",
      lineHeight: "14px",
      width: "calc(100%)"
    }, _defineProperty(_ref2, "display", "block"), _defineProperty(_ref2, "justifyContent", "space-between"), _ref2)
  }, /*#__PURE__*/React__default.createElement(Text, {
    fontFamily: fontFamily.toLowerCase(),
    type: "paragraph",
    fontSize: "xsmall"
  }, textName), extraField) : null, /*#__PURE__*/React__default.createElement(Field, {
    name: name,
    style: {
      width: "100%",
      height: "56px"
    }
  }, function (_ref3) {
    var field = _ref3.field,
      _ref3$form = _ref3.form,
      handleBlur = _ref3$form.handleBlur,
      touched = _ref3$form.touched,
      errors = _ref3$form.errors;
    _ref3$form.setFieldValue;
    return /*#__PURE__*/React__default.createElement(Line, {
      inputValue: field.value,
      inputFocused: isFocused,
      style: {
        width: "100%",
        height: "56px"
      }
    }, /*#__PURE__*/React__default.createElement(TextfieldForm, {
      baseColor: baseColor,
      hasPlaceholder: placeholder ? true : false,
      hasFocus: isFocused,
      color: color,
      style: {
        width: "100%",
        boxSizing: "border-box"
      }
    }, /*#__PURE__*/React__default.createElement(TextField, _extends({
      ref: textInput
    }, field, {
      fontFamily: fontFamily.toLowerCase(),
      fontSize: fontSize,
      baseColor: baseColor,
      height: height,
      color: color,
      border: border,
      autoFocus: autoFocus,
      tabIndex: tabIndex,
      autoComplete: autoComplete,
      type: "otp",
      onFocus: function onFocus() {
        return setIsFocused(true);
      },
      onBlur: function onBlur(e) {
        if (e.relatedTarget && e.relatedTarget.classList.contains("textfield-label")) {
          textInput.current.focus();
        } else {
          handleBlur(e);
          setIsFocused(false);
        }
      },
      hasErrors: get_1(touched, field.name) && get_1(errors, field.name),
      value: field.value && !allowSpace ? field.value.replace(/ /g, "") : field.value ? field.value : "",
      hasFocus: isFocused ? "true" : "false",
      focusIndicator: false,
      placeholder: placeholder ? placeholder : label,
      id: id,
      className: "textfield-input",
      style: style,
      maxLength: length
    })), /*#__PURE__*/React__default.createElement(Text, {
      fontFamily: fontFamily.toLowerCase(),
      type: "paragraph",
      fontSize: "medium",
      className: "textfield-label",
      tag: "label",
      color: "grey-1",
      tabIndex: "0",
      onClick: function onClick() {
        textInput.current.focus();
      },
      style: {
        cursor: "text"
      }
    }, label ? label : ""), /*#__PURE__*/React__default.createElement(LineInputBorder, {
      hasFocus: isFocused,
      hasErrors: get_1(touched, field.name) && get_1(errors, field.name) && !!field.value ? "true" : "false"
    }, /*#__PURE__*/React__default.createElement("div", null))));
  }));
};
WrappedTextInput.defaultProps = _defineProperty({
  type: "text",
  fontFamily: "euclid",
  height: "normal",
  color: "normal"
}, "fontFamily", "graphik");
WrappedTextInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  fontFamily: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  allowSpace: PropTypes.bool,
  mobileNumber: PropTypes.bool //persistentPlaceholder: PropTypes.bool
};

export { WrappedTextInput as default };